import React, { Component } from 'react';
import Tabs from './Tabs/Tabs';
import { ErrorModal } from '../Step1/ErrorModal/ErrorModal';
import { indexOf } from 'lodash'

class Step3 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabs: [],
            positioningData: [],
            ErrorModal: false,
        };
    }
    componentWillMount() {
        let customerSegmentData = {
            projectId: this.props.projectId,
            type: 'segmentation'
        }
        let competeData = {
            projectId: this.props.projectId,
            type: 'compete'
        }
        let positioningStatementData = {
            projectId: this.props.projectId,
            type: 'positioning'
        }
        let cometitorsGroups = {
            projectId: this.props.projectId,
            type: 'competitors'
        }
        let ValueProposition = {
            projectId: this.props.projectId,
            type: 'valueProposition'
        }
        let body = {
            projectId: this.props.projectId,
            type: 'influencerMap'
        }
        this.props.getInfluencerMapGroups(body);
        // this.props.getPositioningStatement(positioningStatementData);
        this.props.getCompete(competeData);
        this.props.getCustomerSegment(customerSegmentData);
        this.props.getCompetitorsGroups(cometitorsGroups)
        this.props.getValueProposition(ValueProposition)
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.valueProposition.valuePropositionFetched && nextProps.valueProposition.valuePropositionData.Items.length > 0 && this.state.tabs.length === 0) {
            this.setState({
                tabs: nextProps.valueProposition.valuePropositionData.Items[0].propositions
            })
        }
        if (!nextProps.valueProposition.createValuePropositionPending && nextProps.valueProposition.createValuePropositionFetched && this.props.groupStepState === 3 && this.state.goNextStep) {
            this.props.groupStateNext();
        }
    }
    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                    <div className='rect1' />
                    <div className='rect2' />
                    <div className='rect3' />
                    <div className='rect4' />
                    <div className='rect5' />
                </div>
            </div>
        );
    }
    onAddPlace = (groupId, segmentId, name, value) => {
        let tabs = this.state.tabs
        tabs.map(item => {
            if (item.groupId === groupId && item.segmentId === segmentId) {
                if (item.place === undefined) {
                    item.place = {
                        review1: [],
                        review2: []
                    }
                }
                item.place[name].push(value)
            }
        })
        this.setState({ tabs })
    }
    onDeleteReview1 = (groupId, segmentId, reviews) => {

        let review1 = []
        let tabs = this.state.tabs
        tabs.map(item => {
            if (item.groupId === groupId && item.segmentId === segmentId) {
                item.place.review1.map(review => {
                    if (review !== reviews) {
                        review1.push(review)
                    }
                })
               item.place.review1 = review1
            }
        })
        this.setState({ tabs })
    }
    onDeleteReview2 = (groupId, segmentId, reviews) => {
        let review2 = []
        let tabs = this.state.tabs
        tabs.map(item => {
            if (item.groupId === groupId && item.segmentId === segmentId) {
                item.place.review2.map(review => {
                    if (review !== reviews) {
                        review2.push(review)
                    }
                })
               item.place.review2 = review2
            }
        })
        this.setState({ tabs })
    }
    onNextButtonClick = () => {
        let emptyValue;
        emptyValue = this.state.tabs.map(item => {
            if (item.place === undefined || item.place.review1 === [] || item.place.review2 === []) {
                return true
            }
        })
        if (indexOf(emptyValue, true) === -1) {
            let body = {
                id: this.props.valueProposition.valuePropositionData.Items[0].id,
                projectId: this.props.projectId,
                type: "valueProposition",
                propositions: this.state.tabs
            }
            this.setState({ goNextStep: true });
            this.props.editValueProposition(body)
        } else {
            this.ErrorModal()
        }
    }
    ErrorModal = () => {
        this.setState({ ErrorModal: !this.state.ErrorModal })
    }

    render() {
        return (
            <div className='criteria-content'>
                <div className='step-bar'>
                    <div className='step step-five arrow-step'>
                        <p>Step 1</p>
                    </div>
                    <div className='step step-five arrow-step '>
                        <p>Step 2</p>
                    </div>
                    <div className='step step-five arrow-step active-step'>
                        <p>Step 3</p>
                    </div>
                    <div className='step step-five arrow-step'>
                        <p>Step 4</p>
                    </div>
                    <div className='step step-five arrow-step '>
                        <p>Result</p>
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className="row">
                      <div className="col-sm-12">
                        <h5>Value Proposition</h5>
                      </div>
                    </div>
                    {(this.props.compete.competeFetching ||
                        //!this.props.positioningStatement.getPositioningStatementFetched ||
                        this.props.compete.competitorsGroupsFetching || !this.props.valueProposition.valuePropositionFetched || !this.props.compete.customerSegmentFetched || this.props.valueProposition.createValuePropositionPending) && this.elementInfiniteLoad()}
                    {!this.props.compete.competeFetching &&
                    //this.props.positioningStatement.getPositioningStatementFetched &&
                    !this.props.compete.competitorsGroupsFetching && this.props.valueProposition.valuePropositionFetched && this.props.compete.customerSegmentFetched &&
                        <div className='row'>

                            <div className="col-md-12">
                                <div className='card'>
                                    <div className="card-header">
                                      <div className="col-md-8">
                                        <div className="criteria-title-box">
                                          <h5>Place</h5>
                                          <span>Identify your place. Where will you deliver your product or service? What will change about who or how will you communicate your message?</span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className='card-body'>
                                        <Tabs
                                            tabs={this.state.tabs}
                                            compete={this.props.compete}
                                            // positioningStatement={this.props.positioningStatement.getPositioningStatementData.Items[0].positioning}
                                            onAddPlace={this.onAddPlace}
                                            projectId={this.props.projectId}
                                            onDeleteReview1={this.onDeleteReview1}
                                            onDeleteReview2={this.onDeleteReview2}
                                            getInfluencerMapGroupsData={this.props.getInfluencerMapGroupsData}
                                            tabStep={this.props.tabStep}
                                            onTabChange={this.props.onTabChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='col-sm-12'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <div className='btn btn-success' onClick={() => this.onNextButtonClick()}>Next</div>
                                        <div className='btn empty-btn default' onClick={() => this.props.groupStateBack()}>Back</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {this.state.ErrorModal &&
                        <ErrorModal
                            ErrorModal={this.ErrorModal}
                        />
                    }
                </div>
            </div>
        )
    }
}

export default (Step3);



// WEBPACK FOOTER //
// ./src/components/ValuePropositionComponent/Step3/Step3.jsx